import { Platform, Dimensions } from "react-native";

export const SCREEN_WIDTH =
  Platform.OS === "web"
    ? Math.min(Dimensions.get("window").width, 600)
    : Dimensions.get("window").width;
